// Unpublished Work © 2021-2022 Deere & Company

import t from 'tcomb';

export const EquipmentItem = t.struct({
    description: t.String,
    serialNumber: t.String
}, 'EquipmentItems');
